import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=7ecf8e3e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ecf8e3e')) {
      api.createRecord('7ecf8e3e', component.options)
    } else {
      api.reload('7ecf8e3e', component.options)
    }
    module.hot.accept("./VideoModal.vue?vue&type=template&id=7ecf8e3e&", function () {
      api.rerender('7ecf8e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/modals/VideoModal.vue"
export default component.exports